import { authFetch } from './client';

// `owner` (optional) reads a project shared by another user (read-only view).
// GET also returns `unitSystem` (HS-60) — null until the owner has picked one.
export const getWorkflow = (projectId, owner) =>
  authFetch(
    `/api/projects/${projectId}/workflow${owner ? `?owner=${encodeURIComponent(owner)}` : ''}`
  );
// `unitSystem` (optional, HS-60) persists the project's unit-system id; the
// backend ignores a null/absent value so it never clears an earlier choice.
export const saveWorkflow = (projectId, nodes, edges, unitSystem) =>
  authFetch(`/api/projects/${projectId}/workflow`, {
    method: 'PUT',
    body: JSON.stringify(unitSystem ? { nodes, edges, unitSystem } : { nodes, edges }),
  });
